import { Locale } from '@/helpers/languages';

export const CHUNK_SIZE_S = 8;
export const CHUNK_SIZE_L = 16;

const perChunkS = {
  desktopL: CHUNK_SIZE_S,
  desktop: CHUNK_SIZE_S,
  tablet: CHUNK_SIZE_S,
  mobile: CHUNK_SIZE_S,
  mobileS: CHUNK_SIZE_S,
};

const perChunkL = {
  desktopL: CHUNK_SIZE_L,
  desktop: CHUNK_SIZE_L,
  tablet: CHUNK_SIZE_L,
  mobile: CHUNK_SIZE_L,
  mobileS: CHUNK_SIZE_L,
};

const MIN_LARGE_CHUNK = 25;

export const perGamesGridChunk = (totalCount: number) =>
  totalCount > MIN_LARGE_CHUNK ? perChunkL : perChunkS;

export const TYPO_CORRECTIONS: Record<string, string> = {
  'i’m': 'i am',
  '3×': '3x',
  búfalo: 'buffalo',
  bokk: 'book',
  'book dead': 'book of dead',
  plinco: 'plinko',
  bacarrat: 'baccarat',
  buffolo: 'buffalo',
  buffaö: 'buffalo',
  buffao: 'buffalo',
  'für book of wealth': 'book of wealth',
  'hold und': 'hold and',
  'hold und wim': 'hold and win',
  'hold und win': 'hold and win',
  olyü: 'olympus',
  hafes: 'hades',
  'boök of paelrs': 'book of pearls',
};

type LanguageCorrection = {
  value: string;
  language: Locale;
};

export const LANGUAGE_CORRECTIONS: Record<string, LanguageCorrection> = {
  würfel: { value: 'rice', language: Locale.GERMAN },
  bücher: { value: 'books', language: Locale.GERMAN },
  buch: { value: 'book', language: Locale.GERMAN },
  '3x3 äg': { value: '3x3 eg', language: Locale.GERMAN },
  ägyp: { value: 'egypt', language: Locale.GERMAN },
  ägypt: { value: 'egypt', language: Locale.GERMAN },
  ägüpt: { value: 'egypt', language: Locale.GERMAN },
  höll: { value: 'hell', language: Locale.GERMAN },
  hölle: { value: 'hell', language: Locale.GERMAN },
  'glückliches kaninchen': { value: 'happy rabbit', language: Locale.GERMAN },
  joketär: { value: 'joker', language: Locale.GERMAN },
  früchte: { value: 'fruit', language: Locale.GERMAN },
};

export const getLanguageCorrectedMessage = ({
  value,
  language,
}: LanguageCorrection) => {
  if (language === Locale.GERMAN) {
    return `Die Suchergebnisse zeigen [${value}], da die Suche nur auf Englisch funktioniert.`;
  }

  if (language === Locale.FRENCH_CANADA) {
    return `Les résultats de recherche affichent [${value}], car la recherche ne fonctionne qu'en anglais.`;
  }

  if (language === Locale.ESTONIA) {
    return `Otsingutulemustes kuvatakse [${value}], kuna otsing töötab ainult inglise keeles.`;
  }

  return value;
};
